import { API_URL } from 'constants';

export const DEFAULT_ABSENCE_TYPE_URL = `${API_URL}/api/v1/absencetype`;
